<template>
  <div
    style="padding-left: 20px;cursor:pointer; width: fit-content; background-color: transparent;"
    @dragstart="dragstart_custom($event, item)"
  >
    <input type="checkbox" v-bind:some-prop="item" v-model="item.selected" :disabled="disable" />
    <span @click="change_status(item)" >
      <i v-if="item.open" class="fa fa-folder-open" aria-hidden="true"></i>
      <i v-else class="fa fa-folder" aria-hidden="true"></i>
      {{item.name}}
      <span v-if="item.count">({{item.count}})</span>
      <span v-else></span>
      <span v-if="isFolder" @click="item.open = !item.open"></span>


      <span v-if="item.path && show_permission">
        <b-badge v-b-tooltip.hover.right :title="msg_uid" :variant="is_root_uid ? 'danger' : 'warning'"> {{item.uid}} </b-badge>
        <b-badge v-b-tooltip.hover.right :title="msg_gid" :variant="is_root_gid ? 'danger' : 'warning'"> {{item.gid}} </b-badge>
        <b-badge v-b-tooltip.hover.right :title="msg_sticky" :variant="is_sticky ? 'danger' : 'light'"> {{item.perm}} </b-badge>
      </span>
    </span>
    <!-- {{os_type}} -->
    <!-- 좀 이상하지만 자기 자신을 컴포넌트로 참조 -->
    <div v-show="item.open" v-if="isFolder">
      <folder
      v-for="(child, index) in item.child"
      :key="child.id"
      :item="child"
      :draggable="!disabled_list.includes(child.name)"

        @path="get_path"
        @dragstart_custom="($event, item) => dragstart_custom($event, item)"

        :show_permission="show_permission"
        :os_type="os_type"
        :msg_uid="msg_uid"
        :msg_gid="msg_gid"
        :msg_sticky="msg_sticky"
      />
    </div>
  </div>
</template>
<script>


export default {
  name: 'folder',
  props: ['item', 'show_permission', 'os_type', 'msg_sticky', 'msg_gid', 'msg_uid'],
  data: function () { return { selected : '', dragged : undefined, disabled_list : ['Windows', 'sys', 'proc', 'dev', 'selinux'] } },
  computed: {
    disable: function() {
      return (this.item.name == '/' || this.item.abs_path.replace(/([A-Za-z]:\\)/gm, '').length < 1) || _.indexOf(this.disabled_list, this.item.name) > -1
    },
    isFolder: function () { return this.item.child && this.item.count },
    is_root_uid: function() { return ['root'].indexOf(this.item.uid) > -1 },
    is_root_gid: function() { return ['root'].indexOf(this.item.gid) > -1 },
    is_sticky: function() { return this.item.perm.endsWith('t') },
  },
  methods: {

    // 다음 패치에 기능 추가 예정
    // select_scan_list(path) {
    //   this.item.selected && path ? this.$parent.$emit('add_scan_list', path) : ''
    // },
    dragstart_custom($event, item) { this.$emit('dragstart_custom', $event, item) },
    change_status(item) {
      if(_.indexOf(this.disabled_list, item.name) > -1) { return console.log("black list", item.name) }
      item.open = !item.open;
      this.get_path(item)
    },
    get_path(c) { this.$emit('path', c) }, // 컴포넌트 자기 자신 참조이므로 스스로에서 에밋
    toggle: function () {
      this.item.open = this.isFolder && !this.open;
      this.open = this.isFolder && !this.open;
      // console.log(this.item)
      this.$parent.$emit('item', this.item)
    },
  },
  created: function() { console.log('folder.vue', 'created'); },
  destroyed: function() { console.log('folder.vue', 'destroyed'); },
  mounted: function() { console.log('folder.vue', 'mounted'); }

}
</script>
